import { queryOptions } from '@tanstack/react-query';
import { getSessionServerFn } from '@/server/functions/auth';

export const sessionQueryOptions = queryOptions({
  queryKey: ['auth-session'],
  queryFn: () => getSessionServerFn().then((s) => s ?? null),
});
